// src/pages/workout/video/AllWorkoutVideosDebug.jsx
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { VIDEOS_BY_ITEM } from "../../../data/videos/workoutVideos";
import legextension2 from "../../../assets/images/legextension2.png"; // 🔹 썸네일 없는 경우 기본 이미지

export default function AllWorkoutVideosDebug() {
    const navigate = useNavigate();

    // VIDEOS_BY_ITEM 전체를 평탄화해서 리스트로 만들기
    const flatList = useMemo(() => {
        const result = [];
        Object.entries(VIDEOS_BY_ITEM || {}).forEach(([groupKey, arr]) => {
            (arr || []).forEach((video) => {
                result.push({
                    groupKey, // upper-body / core-body / lower-body ...
                    ...video, // id, title, thumb, guide, videoUrl ...
                });
            });
        });
        return result;
    }, []);

    const handleGoDetail = (video) => {
        if (!video.id || !video.groupKey) return;

        const qs = new URLSearchParams({
            v: video.id,
            item: video.groupKey,
            cat: "debug", // 그냥 태그용
        }).toString();

        // ▶ 지금 쓰는 디테일 경로로 이동
        navigate(`/workout/video/details?${qs}`);
    };

    return (
        <main className="h-[var(--app-height)] flex flex-col font-suit overflow-y-auto px-7 md:px-8 bg-white">
            <h1 className="text-xl font-bold mt-4 mb-3">
                전체 운동 영상 디버그 리스트
            </h1>

            <p className="text-sm text-gray-500 mb-4">
                각 운동 옆의 버튼을 눌러 디테일 페이지에서 재생이 잘 되는지 확인해보세요.
                (id 나 videoUrl 없는 항목은 빨간색으로 표시됩니다)
            </p>

            <ul className="space-y-2 mb-6">
                {flatList.map((v, idx) => {
                    const hasId = !!v.id;
                    const hasVideoUrl = !!v.videoUrl; // 백엔드 매핑 안 했으면 false일 수도 있음
                    const safeTitle = v.title || `영상 ${idx + 1}`;
                    const thumb = v.thumb || v.thumbnail || legextension2; // 🔹 썸네일 결정

                    return (
                        <li
                            key={`${v.groupKey}-${v.id || idx}`}
                            className="border rounded-lg p-3 flex items-center justify-between gap-3"
                        >
                            {/* 썸네일 */}
                            <div className="shrink-0">
                                <img
                                    src={thumb}
                                    alt={safeTitle}
                                    className="w-14 h-14 md:w-16 md:h-16 object-contain rounded-md border"
                                />
                            </div>

                            {/* 텍스트 정보 */}
                            <div className="min-w-0 flex-1">
                                <p className="text-xs text-gray-400 mb-1">
                                    그룹: {v.groupKey}
                                </p>
                                <p className="text-sm font-semibold truncate">
                                    {safeTitle}
                                </p>
                                <p className="text-[11px] text-gray-400 mt-1 break-all">
                                    id: {v.id || <span className="text-red-500">없음</span>}
                                </p>
                                <p className="text-[11px] text-gray-400 break-all">
                                    videoUrl:{" "}
                                    {hasVideoUrl ? (
                                        <span className="text-green-600">설정됨</span>
                                    ) : (
                                        <span className="text-red-500">없음</span>
                                    )}
                                </p>
                            </div>

                            {/* 디테일 버튼 */}
                            <button
                                type="button"
                                onClick={() => handleGoDetail(v)}
                                disabled={!hasId}
                                className={
                                    "text-xs px-3 py-2 rounded-md whitespace-nowrap " +
                                    (hasId
                                        ? "bg-blue-500 text-white"
                                        : "bg-gray-200 text-gray-500 cursor-not-allowed")
                                }
                            >
                                디테일 열기
                            </button>
                        </li>
                    );
                })}
            </ul>
        </main>
    );
}
